/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, DependencyList } from 'react';

export function useAsync<T>(fn: () => Promise<T>, deps: DependencyList = []) {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | undefined>();
  const [res, setRes] = useState<T | undefined>();

  useEffect(() => {
    setLoading(true);
    let cancel = false;
    fn().then(
      (res) => {
        if (cancel) return;
        setLoading(false);
        setRes(res);
      },
      (error) => {
        if (cancel) return;
        setLoading(false);
        setError(error);
      }
    );
    return () => {
      cancel = true;
    };
  }, deps);

  return { loading, error, res };
}

export default useAsync;